import { type ToastProps } from "@newsela/angelou";
import { useRouter } from "next/router";
import globalToasterRef from "@/base/globalToasterRef";
import { USER_LICENSE_TYPE } from "@/onboarding/onboarding.constants";
import { type Features } from "@/users/v3/features/queries.types";
import { type ContentPreference } from "@/content/queries";
import { toastCss } from "./onboarding.styles";
import type { PreferenceCaptureTaxonomy } from "@/onboarding/onboarding.types";

// TODO: turn this function into a hook and leverage
// `shouldRenderPremiumOnboarding` from `useOnboarding`
export const displayOnboardingToast = (
  toastOptions: ToastProps,
  premiumToast = false,
) =>
  globalToasterRef.current.displayToast({
    ...toastOptions,
    __cssFor: toastCss(premiumToast),
  });

export const getLicenseType = (
  userFeatures: Record<Features[number], string> | undefined,
) => {
  if (userFeatures?.["has_premium_license"]) {
    return USER_LICENSE_TYPE.premium;
  }
  if (userFeatures?.["has_paid_essentials_license"]) {
    return USER_LICENSE_TYPE.essentials;
  }
  if (userFeatures?.["has_active_premium_trial"]) {
    return USER_LICENSE_TYPE.trial;
  }
  if (userFeatures?.["has_nce_trial_campaign"]) {
    return USER_LICENSE_TYPE.nce;
  }

  return USER_LICENSE_TYPE.lite;
};

export const getLicenseTypeFromList = (userFeatures: Features) => {
  if (userFeatures?.includes("has_premium_license")) {
    return USER_LICENSE_TYPE.premium;
  }
  if (userFeatures?.includes("has_paid_essentials_license")) {
    return USER_LICENSE_TYPE.essentials;
  }
  if (userFeatures?.includes("has_active_premium_trial")) {
    return USER_LICENSE_TYPE.trial;
  }
  if (userFeatures?.includes("has_nce_trial_campaign")) {
    return USER_LICENSE_TYPE.nce;
  }

  return USER_LICENSE_TYPE.lite;
};

export const navigateToNextURLOrHome = (
  router: ReturnType<typeof useRouter>,
) => {
  const { next } = router.query;
  window.location.href = next?.toString() || "/";
};

export const getTaxonomiesByLevel = (
  taxonomies: ContentPreference[],
  level: string,
) =>
  taxonomies.filter(
    ({ level: preferenceLevel }) => preferenceLevel.toString() === level,
  );

export const getChildrenTaxonomies = (
  level2Taxonomies: PreferenceCaptureTaxonomy[],
  savedContentPreferences: ContentPreference[],
) => {
  const level1TaxonomyIds = getTaxonomiesByLevel(
    savedContentPreferences,
    "1",
  ).map(({ content_id: contentId }) => contentId);

  return level2Taxonomies.filter(({ parent_id: parentId }) =>
    level1TaxonomyIds.includes(parentId),
  );
};
